import { IApplicationState } from '../../types/redux';

/**
 * Выбирает список статей
 */
export const selectArticleList = ({ articleList }: IApplicationState) => articleList.items;
